import { useRef } from "react";
import ModalPop from "./ModalPop";
import Inquiry from "./Inquiry";

const Contact = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <div
      id="contact"
      className="relative w-full h-full mx-auto pb-14 lg:pb-28 xl:pb-36"
    >
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className=" relative w-full h-fit text-white py-5 lg:py-10">
        <img
          src="/images/contactTitle.png"
          alt="title"
          className="absolute left-0 top-0 w-full h-full"
        />
        <div id="title" className="relative w-full h-fit text-center">
          <p className="pb-3 lg:pb-6 lg:text-2xl">
            믿을 수 있는 하수구업체를 찾고 계시나요?
          </p>
          <h2 className="gbold leading-tight text-point tracking-tighter">
            하수구원킬케어에 <span className="text-red">기회</span>를 주신다면
            <br />
            <span className="text-red">120% 만족스럽게 진행</span>{" "}
            도와드리겠습니다!
          </h2>
          <p className="pt-4 lg:pt-8 lg:text-2xl">
            당일문의 · 당일해결도 가능하며
            <br />
            문의 후 견적비교를 해보셔도 좋습니다.
          </p>
        </div>
      </div>
      <div className="my-8 lg:my-12">
        {/* CTA buttons */}
        <div className="mt-14 grid lg:grid-cols-2 gap-3 md:mt-20 max-w-[700px] mx-auto px-4">
          <button
            type="button"
            onClick={() => (window.location.href = "tel:010-8123-8285")}
            className="w-full rounded-lg bg-gradient-to-r to-secondary via-[#3d7af6] from-[#3d7af6] pt-2 pb-1 text-center text-base text-white transition-colors sm:w-auto"
          >
            <h3>상담신청</h3>
          </button>
          <button
            onClick={openfunc}
            className="w-full rounded-lg border-2 bg-red border-red pt-2 pb-1 text-center text-point transition-colors sm:w-auto text-base"
          >
            <h3>
              긴급출동 <span className="text-base">(365일 24시간)</span>
            </h3>
          </button>
        </div>
        <div className="my-5 lg:my-14">
          <img
            className="object-contain mx-auto max-h-16 lg:max-h-24"
            src="/images/contactLogo.png"
            alt="하수구원킬케어 네이버검색"
          />
        </div>
      </div>
      <div className="relative w-full h-fit px-[calc((100%-var(--container))/2)] max-w-[1600px] mx-auto ">
        <Inquiry />
      </div>
    </div>
  );
};

export default Contact;
